import AdminStaffDetailPage from '../../../components/admin/admin-staff/AdminStaffDetailPage'

export default function AdminStaffDetail() {
  return <AdminStaffDetailPage />
}
